import React from "react"

export default (props) => (
    <div className={'promo-' + props.color}>
        <div className="wrapper">
        {props.children}
        </div>
    </div>

)